import * as url from "../../utils/url"
import * as types from "../mutation-types"
import * as userApi from "../../api/user"
import localStorage from "../../utils/localStorage"
import * as utilsApi from "../../api/utils"
import * as payApi from "../../api/pay"
import * as request from "../../utils/request"
import * as uuid from "../../utils/uuid"

const state = {
  offerId: url.getParam("offerId") || "1450019044",
  selectedZone: "",
  selectedRole: "",
  partitionInfo: "",
  cometUUID: uuid.generate(),
  wzryProps: ""
}
const getters = {
  offerId: state => state.offerId,
  selectedRole: state => state.selectedRole,
  selectedZone: state => state.selectedZone,
  partitionInfo: state => {
    if (state.partitionInfo) {
      return {
        game_platform_id: state.partitionInfo.platid,
        area: state.partitionInfo.area,
        partition: state.partitionInfo.partition
      }
    } else {
      return ""
    }
  },
  cometUUID: state => state.cometUUID,
  wzryProps: state => state.wzryProps
}

const actions = {
  // 清空/初始化
  clearSelectZoneRole({ commit }) {
    commit(types.SET_SELECTED_ZONE, "")
    commit(types.SET_SELECTED_ROLE, "")
    commit(types.SET_PARTITION_INFO, "")
  },
  getMobileZoneInfo({ getters }) {
    let params = {
      openid: getters.loginState.openid,
      openkey: getters.loginState.openkey,
      sessionId: getters.loginState.session_id,
      sessionType: getters.loginState.session_type,
      wxAppid2: getters.loginState.wx_appid,
      offerId: getters.offerId,
      // sandbox: getters.sandbox,
      clientVersion: getters.userAgent.iOS ? "iap" : "android"
    }
    return userApi.getMobileZones(params)
  },
  getMobileRoleInfo({ getters }, { zoneid }) {
    let params = {
      openid: getters.loginState.openid,
      openkey: getters.loginState.openkey,
      sessionId: getters.loginState.session_id,
      sessionType: getters.loginState.session_type,
      wxAppid2: getters.loginState.wx_appid,
      offerId: getters.offerId,
      // sandbox: getters.sandbox,
      clientVersion: getters.userAgent.iOS ? "iap" : "android",
      zoneid
    }
    return userApi.getMobileRoleInfo(params)
  },
  getRoleInfoByPartition({ getters }, { platformId, area, zoneid }) {
    let params = {
      openid: getters.loginState.openid,
      openkey: getters.loginState.openkey,
      sessionId: getters.loginState.session_id,
      sessionType: getters.loginState.session_type,
      wxAppid2: getters.loginState.wx_appid,
      offerId: getters.offerId,
      // sandbox: getters.sandbox,
      clientVersion: getters.userAgent.iOS ? "iap" : "android",
      platformId,
      area,
      zoneid
    }
    return userApi.getRoleInfo(params)
  },
  setSelectedZone({ commit, getters }, zone) {
    commit(types.SET_SELECTED_ZONE, zone)
    localStorage.set(
      `wzry_activity_${getters.offerId}_${getters.loginState.openid}_${getters.userAgent.weixin ? "wx" : "qq"}`,
      JSON.stringify(zone)
    ) //把用户选过的大区存起来
  },
  setSelectedRole({ commit }, role) {
    commit(types.SET_SELECTED_ROLE, role)
  },
  setPartitionInfo({ commit }, partitionInfo) {
    commit(types.SET_PARTITION_INFO, partitionInfo)
  },
  getUserRecommendZone({ getters }) {
    return userApi.getUserRecommend({
      openid: getters.loginState.openid,
      openkey: getters.loginState.openkey,
      sessionId: getters.loginState.session_id,
      sessionType: getters.loginState.session_type,
      wxAppid2: getters.loginState.wx_appid,
      offerId: getters.offerId,
      // sandbox: getters.sandbox,
      model: getters.userAgent.iOS ? "wzry_partition_ios_recomm" : "wzry_partition_android_recomm",
      ext: ""
    })
  },
  placeOrder({ getters }, { zoneid, gameId, productId, productNum, productName, orderExtend = {} }) {
    // let userAgent = ua.getUserAgent(),
    //       //   gameId
    /*
    gameid区分端游和手游拼接模式
    端游为 "大区id_角色id"
    手游为 "area(标识手Q还是微信)_角色id__分区id"
     */

    // gameId = [state.selectedZone.c || (userAgent.weixin ? "1" : "2"), "", "", state.selectedZone.v].join("_")
    let params = {
      pf: `mds_wechat_gmshop-pay_html5_${getters.pf}-${getters.userAgent.iOS ? "iap" : "android"}`,
      offerId: getters.offerId,
      sandbox: getters.sandbox,
      ...getters.loginState
    }
    let extend = {
      is_filter_goods: 1,
      change_openid: 1,
      gameid: gameId,
      game_platform_id: getters.userAgent.iOS ? 0 : 1,
      is_v3_price: 1,
      zoneid,
      payitem: [productId, productNum, getters.offerId].join("*"),
      // is_bargain: 1,
      change_wx_openid: 1,
      goodsmeta: encodeURIComponent(productName) + "*desc",
      ...orderExtend
    }
    return payApi.placeOrder(params, extend)
  },
  midasPay({ getters }, { token, mid, realPrice, directChannel, onQueryResult, drmInfo, dc }) {
    return utilsApi.initMidas().then(Midas => {
      let h5stdPaySuccess = false
      return new Promise(resolve => {
        let data = {
          params: `/v1/${mid}/${getters.offerId}/mobile_goods_info?token_id=${token}`,
          pf: `mds_wechat_gmshop-pay_html5_${getters.pf}-${getters.userAgent.iOS ? "iap" : "android"}`,
          sandbox: getters.sandbox,
          buyGameInfo: getters.userAgent.iOS ? "disableReflow=1" : "dc=hfpay", // 屏蔽点券渠道充值回流，或者屏蔽回流中的话费渠道
          // drm_info: `bargain_group=${config.ACTIVITY[offerId]}&version=3.0&bargain_id=${bargainId}`,
          openid: getters.loginState.openid,
          openkey: getters.loginState.openkey,
          sessionid: getters.loginState.session_id,
          sessiontype: getters.loginState.session_type,
          wxAppid2: getters.loginState.wx_appid,
          closeOnSuccess: 1,
          hideUi: 1,
          hidePrice: 1,
          showCoin: 1,
          supercoupons: "noCoupon", //先屏蔽抵扣券使用
          realPrice,
          dc: "bank,mcard,hfpay,yb,wsjpay,qqcard,ingame_coin",
          // directChannel: "wechat",
          onSuccess: () => {
            h5stdPaySuccess = true
          },
          onClose: () => {
            // resolve("success")
            if (h5stdPaySuccess) {
              resolve("success")
            }
          }
        }

        if (drmInfo) {
          data.drm_info = drmInfo
        }

        if (onQueryResult) {
          data.onQueryResult = function() {
            onQueryResult()
            this.close()
          }
        }

        if (getters.userAgent.weixin) {
          data.change_wx_openid = 1
        }
        if (dc) {
          // 支持传参指定额外的屏蔽渠道
          data.dc = `${dc},${data.dc}`
        }
        if (getters.userAgent.iOS) {
          // iOS内屏蔽现金和QB渠道
          data.dc = `${data.dc},wechat,qqwallet,qdqb,qbqd`
          data.directChannel = "game_coin"
        }
        if (directChannel) {
          data.directChannel = directChannel
          if (directChannel == "game_coin") {
            data.dc = `${data.dc},wechat,qqwallet,qdqb,qbqd`
          }
        }
        Midas.buyGoods(data)
      })
    })
  },
  miniProgramPay({ getters }, { token, mid, groupid }) {
    /**
     * 跳转小程序支付参数说明
     * offerid || goodstokenurl || openid || groupid || buy_quantity || change_wx_openid || pf
     * unit || service_code || identity || wx_appid || zoneid（rechargeInfo里） || product_name（rechargeInfo里）
     * 以上参数支付使用
     *
     * singleton || gameid || productId || offerid
     * 当singleton=1时 结果页缓存已购买信息使用
     *
     * rechargeInfo里 n || accountType || account || name || categoryId || zoneName || action || returnBackText || groupId || busId
     * 结果页展示信息
     * 搭配 goOtherResult
     * 标识回到商店结果页
     */
    let goodstokenurl = encodeURIComponent(`/v1/${mid}/${getters.offerId}/mobile_goods_info?token_id=${token}`)

    let miniPayParam = {
      offerid: String(getters.offerId),
      goodstokenurl: String(goodstokenurl),
      openid: decodeURIComponent(getters.loginState.openid),
      groupid: groupid ? decodeURIComponent(groupid) : "",
      buy_quantity: "",
      change_wx_openid: 1,
      pf: getters.userAgent.iOS ? "iap" : getters.userAgent.android ? "android" : "html5",
      unit: "",
      service_code: "",
      goOtherResult: 2,
      cgiExtend: encodeURIComponent(`uuid=${getters.cometUUID}&pushtype=NodeJS`),
      wx_appid: decodeURIComponent(getters.loginState.wx_appid ? getters.loginState.wx_appid : "")
    }

    // eslint-disable-next-line no-undef
    wx.miniProgram.navigateTo({
      url: "/webview/pages/pay/pay?" + request.serializeParams(miniPayParam)
    })
  },
  comet({ getters }) {
    return request.comet({
      sandbox: getters.sandbox,
      data: {
        uin: getters.loginState.openid,
        skey: getters.loginState.openkey,
        uuid: getters.cometUUID,
        tag: "wzry_activity_comet"
      }
    })
  },
  /**
   * 获取王者荣耀道具配置信息,可以知道物品是皮肤或英雄
   * @param state
   * @returns {Promise<any | string>|Promise<T>}
   */
  getWzryPropsConfig({ getters, commit }, { version, configUrl }) {
    let cacheProps = localStorage.get(`${version}_wzry_props`, true)
    if (cacheProps) {
      commit(types.SET_WZRY_GOODS, cacheProps)
      return Promise.resolve(cacheProps)
    } else {
      return request
        .ajax({
          url: configUrl,
          offerId: getters.offerId
        })
        .then(res => {
          localStorage.set(`${version}_wzry_props`, JSON.stringify(res))
          commit(types.SET_WZRY_GOODS, res)
          return res
        })
    }
  }
}

const mutations = {
  [types.SET_SELECTED_ZONE](state, zone) {
    state.selectedZone = zone
  },
  [types.SET_SELECTED_ROLE](state, role) {
    state.selectedRole = role
  },
  [types.SET_PARTITION_INFO](state, partitoinInfo) {
    state.partitionInfo = partitoinInfo
  },
  [types.SET_WZRY_GOODS](state, goods) {
    state.wzryProps = goods
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
